import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=2f08e4d5&scoped=true&"
import script from "./Questionnaire.vue?vue&type=script&lang=ts&"
export * from "./Questionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=2f08e4d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08e4d5",
  null
  
)

export default component.exports